import { FileUploaderProps, RequestFn, RequestFnParams } from './types';

const UPLOAD_URL = '/api/ddcs/v1/upload';

export function useFileUploaderRequest(settings: FileUploaderProps): RequestFn {
  if (settings.request) return settings.request;
  return function requestFunction({
    file,
    controller,
    restProps,
  }: RequestFnParams) {
    const { fetchParams, options } = restProps;

    const formData = new FormData();
    formData.append('document', file);
    if (options) {
      Object.keys(options).forEach((key) => {
        formData.append(key, options[key]);
      });
    }

    return fetch(UPLOAD_URL, {
      ...fetchParams,
      method: 'POST',
      signal: controller.signal,
      body: formData,
      credentials: 'include',
      mode: 'same-origin',
    });
  };
}
